import Query from '../utils/Query';

const defaultFields = 'id,comment,comment_deleted_on,edited_on,comment_thumb_up,comment_thumb_down,action_on,action_by.screen_name,action_by.first_name,action_by.last_access_on,action_by.last_name,action_by.avatar.private_hash,action_by.id';

export default class CommentService {

	static count(collection, id) {
		return Query.get('/activity?filter[action]=comment&filter[collection]=' + collection + '&filter[item]=' + id + '&fields=' + defaultFields + '&meta=filter_count&limit=0');
	}

	static getAll(collection, id, sort = '-id', limit = 50, parentId = null) {

		return Query.get('/activity?filter[action]=comment&filter[collection]=' + collection + (parentId ? '&filter[comment_parent_id]=' + parentId : '&filter[comment_parent_id][null]') + '&filter[item]=' + id + '&fields=' + defaultFields + '&sort=' + sort + '&meta=filter_count,result_count&limit=' + limit);
	}

	static save(id, collection, comment, parentId) {

		let data = { item: id, collection, comment };
		if (parentId) {
			data.comment_parent_id = parentId;
		}

		return Query.post('/activity/comment?fields' + defaultFields, data);
	}

	static update(id, comment) {

		return Query.patch('/activity/comment/' + id + '?fields=' + defaultFields, {
			comment: comment
		});
	}

	static delete(id) {

		return Query.delete('/activity/comment/' + id);
	}
}
